exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-container{position:fixed;top:0;left:0;background-color:gray;width:100%;height:50px;padding:10px;text-align:center;border-bottom:2px solid rgba(29,46,53,.75);z-index:10}.header-container img{max-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e3a243b","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/Header.vue
// module id = 39
// module chunks = 0